import { Link } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Root = styled(Link)`
  white-space: nowrap;
`;
